export default __webpack_public_path__ + "static/media/carnival-2026.981017d2.png";